import { Component, createRef } from 'react';
import cn from 'classnames';
import { Link } from 'react-router';

import { onEvent } from 'helpers/EventHelpers';
import { constructMSAImageUrl } from 'helpers';
import newCollectionImage from 'images/new_collection_icon.svg';
import css from 'styles/components/account/collectionListCard.scss';

const PRODUCT_IMAGE_SIZE = 100;
const MAX_ICON_IMAGES = 3;
const MSA_IMAGE_DIMENSION = { width: PRODUCT_IMAGE_SIZE, height: PRODUCT_IMAGE_SIZE };

export default class CollectionListCard extends Component {
  constructor(props) {
    super(props);
    this.cardMenu = createRef();
  }

  state = {
    isCardMenuOpen: false,
    unbindCardMenuMethod: null
  };

  componentDidMount () {
    onEvent(document.body, 'click', e => {
      const cardMenu = this.cardMenu.current;
      if (e.target.closest(`.${css.cardMenu}`) !== cardMenu) {
        this.setState({ isCardMenuOpen: false });
      }
    }, null, this);
  }

  makeCollectionIcons = hearts => {
    if (hearts?.length) {
      const heartImagesToMake = Math.min(hearts.length, MAX_ICON_IMAGES);
      const images = hearts.slice(0, heartImagesToMake).map(({ imageId, name }) => <img key={imageId} src={constructMSAImageUrl(imageId, MSA_IMAGE_DIMENSION)} alt={name}/>);
      return (
        <div className={css.groupedImagesContainer}>
          {images}
        </div>);
    } else {
      return (<img className={css.newCollectionsImage} src={newCollectionImage} alt={name}/>);
    }
  };

  onOpenCardMenu = () => {
    this.setState({ isCardMenuOpen: true });
  }

  render() {
    const {
      listId,
      hearts,
      name,
      itemCount,
      onOpenShareModal,
      onOpenDeleteModal,
      hideCardMenu = false } = this.props;
    const { isCardMenuOpen } = this.state;

    return (<article className={css.collectionListCard}>
      <Link to={`/account/favorites/${listId}`}>
        { this.makeCollectionIcons(hearts) }
      </Link>
      <div className={css.details}>
        <div className={css.nameAndMenuContainer}>
          <Link to={`/account/favorites/${listId}`}>{name}</Link>
          {!hideCardMenu && (
              <>
                <button
                  type="button"
                  className={css.cardMenuButton}
                  onClick={this.onOpenCardMenu}
                  aria-label={`Open ${name} collection menu`}>...</button>
                {
                  isCardMenuOpen &&
                  (<div ref={this.cardMenu} className={cn(css.cardMenu)}>
                    <button type="button" data-listid={listId} onClick={onOpenDeleteModal}>Delete</button>
                    <button type="button" data-listid={listId} onClick={onOpenShareModal}>Share List</button>
                  </div>)
                }
              </>)}
        </div>
        <p>{itemCount} items</p>
      </div>
    </article>);
  }
}
